import React from 'react';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import { Modal, Button, Col, Form, Input, Row, message, Radio } from 'antd';
import {
  addMessageToAllImages,
  addMessageToOneImage,
  getImageComments
} from '../../redux/action/sightings/SightingsActions';

import './SightingsModal.css';

const { TextArea } = Input;

const SightingsModal = (props) => {
  const dispatch = useDispatch();
  const getImageCommentsData = useSelector(
    (state) => state.sightingsStore.getImageCommentsData
  );

  const { form, imageData, url } = props;
  const { getFieldDecorator } = form;
  const {
    lastModifyDateFromHeader,
    id,
    domainId,
    reviewStatusChangedBy,
    reviewStatusChangedAt
  } = imageData;

  const [modalIsVisible, setModalIsVisible] = useState(false);

  const imgCommentTASize = (e) => {
    const el = e.target;
    setTimeout(() => {
      el.style.cssText = 'height:auto; padding:0';
      el.style.cssText = 'height:' + el.scrollHeight + 'px';
    }, 0);
  };

  const closeModal = () => {
    form.resetFields();
    setModalIsVisible(false);
  };

  const submitHandler = (e) => {
    e.preventDefault();

    form.validateFields(async (err, values) => {
      if (!err) {
        const { apply, comment } = values;

        let requestData;

        if (comment.trim()) {
          if (apply === 'all') {
            requestData = {
              message: !_.isEmpty(comment) ? comment : '',
              sentFrom: msgPage()
            };

            await dispatch(addMessageToAllImages(domainId, requestData));
            await dispatch(getImageComments(id));
            await props.getImagePreparedData(id);
            await props.getDomainsPreparedData(domainId);
          }

          if (apply === 'one') {
            requestData = {
              message: !_.isEmpty(comment) ? comment : '',
              messageName: id,
              sentFrom: msgPage()
            };

            await dispatch(addMessageToOneImage(requestData));
            await dispatch(getImageComments(id));
            await props.getImagePreparedData(id);
          }
        } else message.error('Comment can not be empty!');

        form.resetFields();
      }
    });
  };

  const msgPage = () => {
    if (url === '/quality_control') return 'QC';
    if (url === '/final_review') return 'FR';
  };

  return (
    <div className='SightingsModal'>
      <div className='comments-space'>
        <strong>Last modified images</strong>
        {!_.isEmpty(lastModifyDateFromHeader) ? (
          <span>{moment(lastModifyDateFromHeader).format('DD-MM-YYYY')}</span>
        ) : (
          <span>No data available</span>
        )}
        <strong>Latest changes on QC</strong>
        {!_.isEmpty(reviewStatusChangedAt) ? (
          <span>{moment(reviewStatusChangedAt).format('DD-MM-YYYY')}</span>
        ) : (
          <span>No data available</span>
        )}
        <strong>Made by:</strong>
        {!_.isEmpty(reviewStatusChangedBy) ? (
          <span>{reviewStatusChangedBy}</span>
        ) : (
          <span>No data available</span>
        )}
      </div>
      <div>
        <Modal
          title={<h4 style={{ textAlign: 'center' }}>Comments</h4>}
          centered
          visible={modalIsVisible}
          onCancel={closeModal}
          keyboard={false}
          maskClosable={false}
          destroyOnClose={true}
          width={1200}
          footer={null}
        >
          {!_.isEmpty(getImageCommentsData) ? (
            <div className='img-comments'>
              <div className='img-comment'>
                <p className='img-comment-msg'>
                  {getImageCommentsData[0].message}
                </p>
                <div className='img-comment-info'>
                  <span className='img-comment-date'>
                    {`${moment(getImageCommentsData[0].createdAt).format(
                      'DD-MM-YYYY hh:mm'
                    )}
                                `}
                  </span>
                  <span>
                    <span className='img-comment-creator'>
                      by {getImageCommentsData[0].createdBy} on{' '}
                      {getImageCommentsData[0].sentFrom}
                    </span>
                    {/* <span className="img-comment-sentFrom">
                                        {`${getImageCommentsData[0].sentFrom}`}
                                    </span> */}
                  </span>
                </div>
              </div>
              {getImageCommentsData[0].submessages.map((obj) => (
                <div className='img-comment' key={obj.id}>
                  <p className='img-comment-msg'>{obj.message}</p>
                  <div className='img-comment-info'>
                    <span className='img-comment-date'>
                      {`${moment(obj.createdAt).format('DD-MM-YYYY hh:mm')}
                                    `}
                    </span>
                    <span>
                      <span>
                        by {obj.createdBy} on {obj.sentFrom}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <h4 className='no-img-comments'>No comments yet...</h4>
          )}
          <Form style={{ padding: '0 2rem' }} onSubmit={submitHandler}>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '1rem'
              }}
            >
              <Col style={{ width: '100%' }}>
                <Form.Item style={{ marginBottom: 0 }}>
                  {getFieldDecorator('comment', {
                    rules: [
                      {
                        required: true,
                        message: 'This field cannot be empty.'
                      }
                    ]
                  })(
                    <TextArea
                      rows={2}
                      placeholder='Type in your comment...'
                      onKeyDown={imgCommentTASize}
                    ></TextArea>
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <Form.Item style={{ marginBottom: 0 }}>
                {getFieldDecorator('apply', {
                  rules: [
                    {
                      required: true,
                      message: 'This field cannot be empty.'
                    }
                  ]
                })(
                  <Radio.Group>
                    <Radio value='one' style={{ marginRight: '1rem' }}>
                      Apply to one sighting
                    </Radio>
                    <Radio value='all' style={{ marginRight: '1rem' }}>
                      Apply to all sightings
                    </Radio>
                  </Radio.Group>
                )}
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button type='primary' htmlType='submit'>
                  Add a comment
                </Button>
              </Form.Item>
            </Row>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default Form.create({ name: 'SightingsModal' })(SightingsModal);
